'use strict';
var React = require('react');
module.exports = function () {
    function onClick1(provider, providerIndex, x) {
        this.signIn(provider);
    }
    function onClick2(provider, providerIndex, x) {
        this.clickOnServerSideLogin(provider);
    }
    function repeatProvider3(provider, providerIndex) {
        return [
            this.loginProviders[provider] === 'clientSide' ? React.createElement('li', {
                'className': 'login-provider-list__item' + ' ' + _.transform({
                    'metype-purchase-login': true,
                    'facebook-login': provider === 'facebook',
                    'metype-purchase-login': true,
                    'google-login': provider === 'google'
                }, function (res, value, key) {
                    if (value) {
                        res.push(key);
                    }
                }, []).join(' '),
                'id': 'login-' + provider,
                'onClick': onClick1.bind(this, provider, providerIndex),
                'key': providerIndex
            }, React.createElement('a', {
                'href': 'javascript:void(0)',
                'className': provider
            }, this.props.accountSignupModal ? React.createElement('span', { 'key': '679' }, 'Continue with ') : null, provider)) : null,
            this.loginProviders[provider] === 'serverSide' ? React.createElement('li', {
                'className': 'login-provider-list__item' + ' ' + _.transform({
                    'metype-purchase-login': true,
                    'twitter-login': provider === 'twitter',
                    'metype-purchase-login': true,
                    'linkedin-login': provider === 'linkedin'
                }, function (res, value, key) {
                    if (value) {
                        res.push(key);
                    }
                }, []).join(' '),
                'id': 'login-' + provider,
                'key': providerIndex,
                'onClick': onClick2.bind(this, provider, providerIndex)
            }, React.createElement('a', {
                'href': 'javascript:void(0)',
                'className': provider,
                'target': '_top'
            }, this.props.accountSignupModal ? React.createElement('span', { 'key': '1291' }, 'Continue with ') : null, provider)) : null
        ];
    }
    return React.createElement('div', { 'className': 'login-provider' }, React.createElement('div', { 'className': 'login-provider-title callout-link' }, 'Sign in with'), React.createElement.apply(this, [
        'ul',
        { 'className': 'login-provider-list' },
        _.map(Object.keys(this.loginProviders), repeatProvider3.bind(this))
    ]));
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/pages/metype_home/list_component.rt
// module id = 342
// module chunks = 5 7